import { Link } from "react-router-dom";
import { Scissors, User, Heart, Package } from "lucide-react";
import { Sheet, SheetContent, SheetTitle, SheetDescription } from "./ui/sheet";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "./ui/accordion";
import { BRAND } from "../data/mock";
import { BREEDS, CATEGORIES, FEATURED_BRANDS, MENU, shopLink } from "../data/shopMenu";
import { GROOMING_LINKS, BrandTile } from "./SiteHeader";
import { useStoreBrands } from "../store/CartContext";

const Item = ({ value, title, children }) => (
  <AccordionItem value={value} className="border-[#3915AA]/10">
    <AccordionTrigger data-testid={`mobile-menu-${value}`} className="py-3.5 text-[15px] font-bold text-[#1E0A5C] hover:no-underline">{title}</AccordionTrigger>
    <AccordionContent>{children}</AccordionContent>
  </AccordionItem>
);

export default function MobileMenu({ open, onClose }) {
  const live = useStoreBrands() || [];
  const L = ({ to, children, className = "" }) => <Link to={to} onClick={onClose} className={`block py-1.5 text-sm text-[#5E5675] hover:text-[#FC5106] ${className}`}>{children}</Link>;
  return (
    <Sheet open={open} onOpenChange={(v) => !v && onClose()}>
      <SheetContent side="left" data-testid="mobile-menu" className="w-[88vw] max-w-sm overflow-y-auto border-0 bg-white p-0 text-[#1E0A5C] [&>button]:text-white">
        <div className="bg-[#3915AA] px-5 py-5">
          <SheetTitle><img src={BRAND.logoWhiteUrl} alt="BarknFurs" className="h-8" /></SheetTitle>
          <SheetDescription className="sr-only">Site navigation</SheetDescription>
          <div className="mt-4 grid grid-cols-3 gap-2 text-center text-[11px] font-semibold text-white">
            {[[User, "Account", "/account"], [Heart, "Wishlist", "/account?tab=wishlist"], [Package, "Track", "/track-order"]].map(([I, l, to]) => (
              <Link key={l} to={to} onClick={onClose} className="rounded-xl bg-white/10 py-2.5"><I className="mx-auto mb-1 h-4 w-4" />{l}</Link>
            ))}
          </div>
        </div>
        <div className="px-5 pb-8">
          <Accordion type="single" collapsible>
            {["Dog", "Cat"].map((pet) => (
              <Item key={pet} value={pet.toLowerCase()} title={pet === "Dog" ? "Dogs" : "Cats"}>
                <Accordion type="single" collapsible className="pl-2">
                  {MENU[pet].map(([cat, subs]) => (
                    <AccordionItem key={cat} value={cat} className="border-0">
                      <AccordionTrigger className="py-2 text-sm font-semibold text-[#3915AA] hover:no-underline">{CATEGORIES[cat]}</AccordionTrigger>
                      <AccordionContent className="pl-3">
                        <L to={shopLink(pet, cat)} className="font-semibold text-[#FC5106]">All {CATEGORIES[cat]}</L>
                        {subs.map((s) => <L key={s} to={shopLink(pet, cat, s)}>{s}</L>)}
                      </AccordionContent>
                    </AccordionItem>
                  ))}
                </Accordion>
              </Item>
            ))}
            <Item value="brands" title="Brands">
              <div className="grid grid-cols-2 gap-2">{[...new Set([...live, ...FEATURED_BRANDS])].map((b) => <BrandTile key={b} b={b} live={live.includes(b)} onClick={onClose} className="min-h-[44px] py-2 !text-xs" />)}</div>
              <L to="/brands" className="mt-2 font-bold text-[#FC5106]">View all brands</L>
            </Item>
            <Item value="breeds" title="Shop by Breed">
              <div className="grid grid-cols-4 gap-2">{BREEDS.map((b) => <Link key={b.slug} to={`/breeds/${b.slug}`} onClick={onClose} className="text-center"><img src={b.img} alt="" className="aspect-square w-full rounded-xl object-cover" /><span className="mt-1 block text-[10px] font-semibold leading-tight">{b.name}</span></Link>)}</div>
            </Item>
            <Item value="grooming" title="Grooming & Spa">{GROOMING_LINKS.map(([l, to]) => <L key={l} to={to}>{l}</L>)}</Item>
          </Accordion>
          {[["Flash Deals", "/shop/all?sort=discount"], ["Blog", "/blog"], ["About", "/about"], ["Contact", "/contact"]].map(([l, to]) => (
            <Link key={l} to={to} onClick={onClose} className="block border-b border-[#3915AA]/10 py-3.5 text-[15px] font-bold">{l}</Link>
          ))}
          <Link to="/contact" onClick={onClose} data-testid="mobile-book-cta" className="mt-6 flex items-center justify-center gap-2 rounded-full bg-[#FC5106] py-3.5 text-sm font-bold text-white"><Scissors className="h-4 w-4" /> Book Grooming</Link>
        </div>
      </SheetContent>
    </Sheet>
  );
}
